// components/common/PageContainer/PageContainer.jsx
const PageContainer = ({ children, className = "" }) => {
  return <div className={`container py-4 ${className}`.trim()}>{children}</div>;
};

export default PageContainer;
